module.exports = __webpack_public_path__ + "img/icon-doc.5ba2891a.svg";